export const PREFERRED_RETAILERS = {
    PREFERRED_RETAILERS_LINK: "preferred_retailers",
    COMPANY_SEARCH: "company-search-field",
    COMPANY_NAME: "company-name",
    SELECT_COMPANY: "select-company",
    REMOVE_COMPANY: "remove-company",
    SAVE: "save",
};
